import React from 'react'
import PropTypes from 'prop-types'

import isEmpty from 'lodash/isEmpty'

import UserReviewDetails from './UserReviewDetails'
import ProductReviewContent from './ProductReviewContent'
import ProductReviewRating from './ProductReviewRating'
import ProductReviewThumbnail from './ProductReviewThumbnail'

import '../../../../scss/components/_product-review.scss'

export const ProductReview = ({review}) => (
  <div className="product-review-container">
    <UserReviewDetails
      score={review.score}
      user={review.user}
      date={review.dateSubmitted}
      event={review.event}
    />
    <ProductReviewContent title={review.title} content={review.content} />
    <ProductReviewRating meter={review.ratings} />
    {review.images && !isEmpty(review.images.thumbUrl) && (
      <ProductReviewThumbnail image={review.images} />
    )}
  </div>
)

ProductReview.propTypes = {
  review: PropTypes.shape({
    score: PropTypes.number.isRequired,
    user: PropTypes.shape({}).isRequired,
    dateSubmitted: PropTypes.string.isRequired,
    event: PropTypes.string,
    title: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired,
    ratings: PropTypes.shape({}).isRequired,
    images: PropTypes.shape({
      thumbUrl: PropTypes.string,
    }).isRequired,
  }).isRequired,
}

export default ProductReview
